/* [PATCH izdaja-ui v1] Pas davčnega čuvaja: napake (blokirajo izdajo), opozorila (potrdiš z enim klikom), info (razlaga).
   Vsebina pride s strežnika (poslovni_dok.cuvaj) — UI ničesar ne ugiba (načelo 3: davek odloča pravilo). */
import React from 'react';
import { ShieldAlert, ShieldCheck, AlertTriangle, Info } from 'lucide-react';

import { VRSTA_DDV_OZNAKE } from '../../lib/izdajaZneski'; // [PATCH izdaja-ddv-odlocitev v1c]
export type CuvajZadetek = { koda: string; stopnja: string; besedilo: string; polje?: string; zap?: number; popravek?: string };
const OZNAKA = (k: string) => (VRSTA_DDV_OZNAKE as Record<string, string>)[k] || k; // [PATCH izdaja-ddv-odlocitev v1c] napis vrste namesto kode
export type CuvajIzid = { ok?: boolean; rezim?: string; napake?: CuvajZadetek[]; opozorila?: CuvajZadetek[]; info?: CuvajZadetek[]; klavzule?: string[]; cas?: string };

const REZIM_OZNAKE: Record<string, string> = {
  domaci: 'domači kupec', eu_zavezanec: 'kupec z ID za DDV iz EU', eu_potrosnik: 'potrošnik iz EU', tretja: 'kupec izven EU',
};

export function CuvajPas({ izid, onPopravek }: { izid: CuvajIzid | null | undefined; onPopravek?: (z: CuvajZadetek) => void }) {
  if (!izid || (!izid.napake && !izid.opozorila && !izid.info)) {
    return (
      <div className="rounded-xl border border-dashed border-gray-300 dark:border-gray-700 p-3 text-sm text-gray-500 flex items-center gap-2">
        <ShieldCheck className="w-4 h-4" /> Davčni čuvaj preveri dokument ob shranjevanju.
      </div>
    );
  }
  const napake = izid.napake || [], opozorila = izid.opozorila || [], info = izid.info || [];
  const barva = napake.length ? 'border-rose-300 bg-rose-50 dark:bg-rose-500/10' : opozorila.length ? 'border-amber-300 bg-amber-50 dark:bg-amber-500/10' : 'border-emerald-300 bg-emerald-50 dark:bg-emerald-500/10';
  const Ikona = napake.length ? ShieldAlert : ShieldCheck;
  return (
    <div className={`rounded-xl border p-3 text-sm ${barva}`}>
      <div className="flex items-center gap-2 font-semibold">
        <Ikona className="w-4 h-4" />
        {napake.length ? `Davčni čuvaj: ${napake.length} napak${napake.length === 1 ? 'a' : napake.length === 2 ? 'i' : 'e'} — izdaja ni mogoča`
          : opozorila.length ? `Davčni čuvaj: ${opozorila.length} opozoril${opozorila.length === 1 ? 'o' : opozorila.length === 2 ? 'i' : ''} — potrdiš ob izdaji`
            : 'Davčni čuvaj: vse v redu'}
        {izid.rezim && <span className="ml-auto text-xs font-normal text-gray-500">{REZIM_OZNAKE[izid.rezim] || izid.rezim}</span>}
      </div>
      <ul className="mt-2 space-y-1">
        {napake.map((z, i) => (
          <li key={'n' + i} className="flex items-start gap-2">
            <ShieldAlert className="w-4 h-4 mt-0.5 text-rose-600 flex-shrink-0" />
            <span>{z.zap ? <span className="text-gray-500">vrstica {z.zap}: </span> : null}{z.besedilo}</span>
            {z.popravek && onPopravek && (
              <button type="button" onClick={() => onPopravek(z)} className="ml-auto text-xs px-2 py-0.5 rounded border border-rose-300 hover:bg-white dark:hover:bg-gray-800 whitespace-nowrap">Popravi → {OZNAKA(z.popravek)}</button>
            )}
          </li>
        ))}
        {opozorila.map((z, i) => (
          <li key={'o' + i} className="flex items-start gap-2">
            <AlertTriangle className="w-4 h-4 mt-0.5 text-amber-600 flex-shrink-0" />
            <span>{z.zap ? <span className="text-gray-500">vrstica {z.zap}: </span> : null}{z.besedilo}</span>
            {(z.popravek || z.koda === 'AVANS_ODPRT') && onPopravek && (/* [PATCH izdaja-ddv-odlocitev v1c] uporabnik lahko z enim klikom sprejme predlog čuvaja; [PATCH izdaja-poracun-avansa v2] AVANS_ODPRT */
              <button type="button" onClick={() => onPopravek(z)} className="ml-auto text-xs px-2 py-0.5 rounded border border-amber-400 hover:bg-white dark:hover:bg-gray-800 whitespace-nowrap">{z.koda === 'AVANS_ODPRT' ? 'Poračunaj avans' : `Upoštevaj predlog → ${OZNAKA(z.popravek || '')}`}</button>
            )}
            {(z as any).osnutek_id && <a href={`/izdaja/${(z as any).osnutek_id}`} className="text-xs text-blue-600 hover:underline whitespace-nowrap">odpri osnutek</a>}{/* [PATCH izdaja-poracun-avansa v2e] */}
          </li>
        ))}
        {info.map((z, i) => (
          <li key={'i' + i} className="flex items-start gap-2 text-gray-600 dark:text-gray-300">
            <Info className="w-4 h-4 mt-0.5 text-sky-600 flex-shrink-0" />
            <span>{z.besedilo}</span>
            {(z as any).osnutek_id && <a href={`/izdaja/${(z as any).osnutek_id}`} className="ml-auto text-xs text-blue-600 hover:underline whitespace-nowrap">odpri osnutek</a>}{/* [PATCH izdaja-poracun-avansa v2e] */}
          </li>
        ))}
      </ul>
    </div>
  );
}
